<template>
  <ZigzagServiceLayout
    mainTitle="Ear Lobe Repair & Non-Surgical Reshaping"
    mainDescription="At Diverse Care Now, we offer simple and safe procedures designed to improve appearance and symmetry, and repair ear lobes — without the need for traditional surgery. Minimal downtime with professional care."
    :sections="sections"
  />
</template>

<script>
import ZigzagServiceLayout from '../../../components/ZigzagServiceLayout.vue';

export default {
  name: 'EarLobeRepairContentEn',
  components: {
    ZigzagServiceLayout,
  },
  data() {
    return {
      sections: [
        {
          label: 'AESTHETICS & REPAIR',
          title: 'Benefits & Techniques',
          subtitle: 'Restoring shape naturally and safely.',
          paragraphs: [
            "We use non-surgical otomodeling techniques to help patients with stretched, torn, or asymmetrical earlobes. Whether caused by heavy earrings or natural irregularities, our treatments restore volume and balance seamlessly.",
            "Using advanced Dermal Fillers, PDO Threads, or PRP Rejuvenation, we gently lift, correct angles, and restore skin elasticity without the scarring of traditional surgery."
          ],
          list: [
            "Dermal Fillers for restored shape and volume",
            "PDO / PLLA Threads for minimally invasive lifting",
            "PRP Rejuvenation to restore skin elasticity",
            "Perfect for stretched lobes or protruding ears"
          ],
          videoEmbeds: [
            'https://www.youtube.com/embed/9rbA47bOvms'
          ]
        },
        {
          label: 'PROCEDURE',
          title: 'Procedure Overview & Details',
          subtitle: 'Quick, safe, and comfortable.',
          paragraphs: [
            "Our minimally invasive treatments are performed in-office with local anesthesia to ensure your maximum comfort. The careful application of fillers or threads yields immediate, satisfying results.",
            "You can expect a very quick recovery with only mild swelling that subsides within 24 to 48 hours. We also offer minor cyst removal using the same safe, patient-first approach."
          ],
          list: [
            "Local anesthesia applied for complete comfort",
            "Immediate results with balanced contours",
            "Minimal swelling (resolves in 24–48 hours)",
            "Safe, minor cyst removal available"
          ],
          image: '/images/services/earlobe-repair.png'
        }
      ]
    };
  }
};
</script>
